// frontend/src/utils/slug.js

export const slugify = (s) =>
    String(s || '')
      .trim()
      .toLowerCase()
      // replace any run of non-alphanumeric chars with a single hyphen
      .replace(/[^a-z0-9]+/g, '-')
      // trim leading/trailing hyphens
      .replace(/^-+|-+$/g, '');
  
  export const unslugify = (slug) =>
    String(slug || '')
      .replace(/-/g, ' ')
      .trim();
  